import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { SaleOrder } from "../state/types"

export const useSaleActions = () => {
    const saveActions = useSaveActions()

    const saveSale = (sale: SaleOrder) => {
        const { save } = saveActions()
        return save(TableName.SALE_ORDERS, sale) as Promise<SaleOrder>
    }

    const removeSale = (id: string) => {
        const { remove } = saveActions()
        return remove(TableName.SALE_ORDERS, id)
    }

    return {
        saveSale,
        removeSale
    }
}
